export default __webpack_public_path__ + "static/media/daylotts5000_icon.398e973d.svg";